export default __webpack_public_path__ + "static/media/dhananjay_core.2a927941.jpg";